export type SignUpFormSnapshot = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  termsAccepted: boolean;
  newsletterOffers: boolean;
  newsletterInsights: boolean;
  hasAddress: boolean;
};

/**
 * Whether the sign-up form has any unsaved input — drives the "leave the form?"
 * confirmation when the user navigates away.
 */
export function isSignUpFormDirty(state: SignUpFormSnapshot): boolean {
  return (
    state.firstName.trim() !== '' ||
    state.lastName.trim() !== '' ||
    state.phone.trim() !== '' ||
    state.email.trim() !== '' ||
    state.termsAccepted ||
    state.newsletterOffers ||
    state.newsletterInsights ||
    state.hasAddress
  );
}
